@if (iframeUrl) {
  <div class="-mx-5 md:-mx-10 lg:-mx-15 xl:-mx-[15%] mt-2">
    <iframe
      #fsIframe
      [src]="iframeUrl"
      [style.height.px]="iframeHeight()"
      title="My Tickets"
      class="fs-embed">
    </iframe>
  </div>
}
